import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { EditorState } from '@atlaskit/editor-prosemirror/state';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { applyToolCalls } from '../ui/utils/toolCalls/applyToolCalls';

import type { ShowSuggestionDiffAction } from './types';

export const showSuggestionDiffAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => ShowSuggestionDiffAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(id: string, options?: { hideDeletedDiffs?: boolean }): boolean => {
		let found = false;
		api?.core?.actions.execute(({ tr }) => {
			const suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
			if (!suggestion) {
				return tr;
			}
			found = true;
			// Apply tool calls to an isolated transaction so we can read its `steps`
			// and `before` for diff visualisation without affecting the source transaction.
			// PM nodes are immutable, so reusing tr.doc is safe.
			const isolatedTr = EditorState.create({ doc: tr.doc }).tr;
			const appliedTr = applyToolCalls({ tr: isolatedTr, suggestion });
			api?.showDiff?.commands.showDiff({
				steps: appliedTr.steps.reverse().map((step) => step.invert(appliedTr.before)),
				originalDoc: appliedTr.doc,
				isInverted: true,
				diffType: 'step',
				hideDeletedDiffs: options?.hideDeletedDiffs,
			})({ tr });
			return tr;
		});
		return found;
	};
